import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";

import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import DriveEtaRoundedIcon from '@mui/icons-material/DriveEtaRounded';
import LocalAtmRoundedIcon from '@mui/icons-material/LocalAtmRounded';
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';
import ExpoPartecipazioniDotazioniTable from "./ExpoPartecipazioniDotazioniTable";
import MDAlert from "common/components/MD/MDAlert/MDAlert";

function ExpoPartecipazioneMyDotazioniList({richiesta,filtra}) {

  const [lista_dotazioni, setLista_dotazioni] = useState([]);
   useEffect(() => {

        setLista_dotazioni(richiesta.dotazioni);
    }, []);


  const ppAttributes = [];

  if (lista_dotazioni.length > 0) {

    lista_dotazioni.forEach(dot => {

      let icon = (<Icon>edit</Icon>);

      if (dot.tipo_dotazione == "PE") icon = (<EngineeringRoundedIcon color="success"/>);
      if (dot.tipo_dotazione == "PA") icon = (<DriveEtaRoundedIcon color="success"></DriveEtaRoundedIcon>);
      if (dot.tipo_dotazione == "IO") icon = (<CardGiftcardRoundedIcon color="success"></CardGiftcardRoundedIcon>);
      if (dot.tipo_dotazione == "IR") icon = (<LocalAtmRoundedIcon color="success"></LocalAtmRoundedIcon>);

      let string_tipo_dotazione = "***";
      if (dot.tipo_dotazione == "PE") string_tipo_dotazione = "PASS ESPOSITORE";
      if (dot.tipo_dotazione == "PA") string_tipo_dotazione = "PASS AUTO";
      if (dot.tipo_dotazione == "IO") string_tipo_dotazione = "BIGLIETTI OMAGGIO";
      if (dot.tipo_dotazione == "IR") string_tipo_dotazione = "BIGLIETTI RIDOTTI";

      let assegnati=0;
      if (dot.tipo_dotazione == "PE") assegnati = richiesta.num_pe_assegnati;
      if (dot.tipo_dotazione == "PA") assegnati="*";
      if (dot.tipo_dotazione == "IO") assegnati=richiesta.num_io_assegnati;
      if (dot.tipo_dotazione == "IR") assegnati=richiesta.num_ir_assegnati;

      ppAttributes.push({
        dotazione: dot,
        id_dotazione: dot.id_dotazione,
        id_partecipazione: dot.id_partecipazione,
        origine: dot.origine,
        tipo_dotazione: dot.tipo_dotazione,
        quantita: dot.quantita,
        assegnati:assegnati,
        icona: icon,
        string_tipo_dotazione: string_tipo_dotazione,
      })
    });
  }



  const ppTableData = {
    rows: ppAttributes,

    columns: [

      { Header: "", accessor: "icona", width: "5%", align: "left", id: "dotazioni_0" },
      { Header: "Dotazione", accessor: "string_tipo_dotazione", align: "left", id: "dotazioni_1" },
      { Header: "Origine", accessor: "origine", align: "left", with: "10%", id: "dotazioni_2" },
      { Header: "Quantità", accessor: "quantita", align: "right", width: "5%", id: "dotazioni_3" },
       { Header: "Utilizzati", accessor: "assegnati", align: "right", width: "5%", id: "dotazioni_4" }

    ],



  };

  const mypagination = { color: 'success', variant: "contained" };




  return (





    <Card sx={{ height: "100%", boxShadow: true && "none" ,mx:10}}>
     
       {(lista_dotazioni != null || lista_dotazioni.length > 0) &&
       <MDBox >
      <MDBox pt={2} px={2}>
        <MDTypography color='success' sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
          &nbsp;&nbsp;Hai a disposizione le seguenti dotazioni:&nbsp;
        </MDTypography>
      </MDBox>


      <MDBox pt={3}>
        <ExpoPartecipazioniDotazioniTable
          canSearch={false}
          table={ppTableData}
          nome_tabella="dotazioni_espositore"
          isSorted={true}
          entriesPerPage={true}
          showTotalEntries={true}
          pagination={mypagination}
          noEndBorder
          responsive={true}
          enableColumnFilters={false}
          chiamante='expo_partecipazioni_assign'
  
        />
      </MDBox>


</MDBox>
       }
      {(lista_dotazioni == null || lista_dotazioni.length === 0) &&
        <MDBox style={{ height: "200px" }} textAlign='center'>
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
          >
            Non ci sono Dotazioni disponibili per te per la Manifestazione selezionata.
          </MDTypography></MDBox>
      }
    </Card>




  );
}



export default ExpoPartecipazioneMyDotazioniList;
